export default {
    computedOrders () {
        return this.orders.map(order => {
            return {
                ...order,
                travelerName: order.buyerName,
            }
        })
    }
}
